import {Component, Input, OnInit, Output, EventEmitter} from '@angular/core';
import {SbLocalTime} from '../../services/api/api-date-time';
import {FormGroup} from '@angular/forms';

@Component({
  selector: 'sb-time-input',
  templateUrl: './sb-time-input.component.html',
  styleUrls: ['./sb-time-input.component.scss'],
  standalone: false,
})
export class SbTimeInputComponent implements OnInit {
  @Input() hour: number;
  @Input() minute: number;
  @Input() error: string = null;
  @Input() formInputName: string;
  @Output() onChangeEvent = new EventEmitter<[number, number]>();

  touched: boolean = false;
  formatError: string = null;

  _model: SbLocalTime;

  constructor() {}

  @Input('model')
  set model(value: SbLocalTime) {
    this._model = value;
  }

  get model(): SbLocalTime {
    return this._model;
  }

  ngOnInit(): void {}

  onChange($event): void {
    this.touched = true;
    const time = $event?.target?.value;
    let [hour, minute] = time.split(':');
    hour = +hour;
    minute = +minute;

    if (!isNaN(hour) && !isNaN(minute)) {
      this.hour = hour < 24 ? hour : 23;
      this.minute = minute < 60 ? minute : 59;
      this.formatError = null;
    } else {
      this.hour = 0;
      this.minute = 0;
      this.formatError = 'error.time.invalid';
    }
    $event.target.value = this.getModelString();
    this.onChangeEvent.emit([this.hour, this.minute]);
  }

  getModelString(): string {
    if (this.model) {
      return ('00' + this.model?.value?.hour).slice(-2) + ':' + ('00' + this.model?.value?.minute).slice(-2);
    } else {
      return ('00' + this.hour).slice(-2) + ':' + ('00' + this.minute).slice(-2);
    }
  }
}
